import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

export const startBoomerangRender = async ({ eventId, mediaId }) => {
  const app = getApp();
  const functions = getFunctions(app, "us-central1");
  const fn = httpsCallable(functions, "createBoomerang");
  return fn({ eventId, mediaId });
};